export const en = {
    'categories-cannot-be-empty': 'The filter must contain at least one category',
    'condition-control-cannot-be-empty': 'The field cannot be empty',
    'condition-control-greater-or-equal-min': 'The value must be more than or equal to {min}',
    'condition-control-interval-size': 'Number of elements must be from {min} to {max}',
    'condition-control-invalid-value': 'Incorrect value',
    'condition-control-less-or-equal-max': 'The value must be less than or equal to {max}',
    'condition-invalid-format': 'Incorrect format',
    'condition-prohibited-symbols': 'Invalid characters in field',
    'conditions-cannot-be-empty': 'The filter must contain at least one condition',
    'conditions-must-be-unique': 'Duplicated conditions in filter',
    'default-error': 'Unknown error: {errorCode}',
    'filters-must-be-unique': 'A filter already exists with these criteria and target audience',
    'name-cannot-be-empty': 'Name cannot be empty',
    'name-greater-than-max': 'The maximum length of the name is {max}',
    'name-less-than-min': 'The minimum length of the name is {min}',
    'name-prohibited-symbols': 'Invalid characters in filter name',
    'price-less-than-min': 'Bid cannot be less than {min} {currency}',
    'price-more-than-max': 'Bid cannot be more than {max} {currency}'
};
